import { render, staticRenderFns } from "./notifications-sms.vue?vue&type=template&id=20d6a704&scoped=true"
import script from "./notifications-sms.vue?vue&type=script&lang=ts"
export * from "./notifications-sms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d6a704",
  null
  
)

export default component.exports